import axiosInstance from './AxiosInstance';

const API_URL = 'expertise';

export const getExpertise = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        console.error('Error fetching expertises', error);
        throw error;
    }
};

export const getExpertiseById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/view/${id}`);
        return response.data;
    } catch (error) {
        console.error(`Error fetching expertise with id ${id}`, error);
        throw error;
    }
};

export const createExpertise = async (expertise) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/add`, expertise);
        return response.data;
    } catch (error) {
        console.error('Error creating expertise', error);
        throw error;
    }
};

export const updateExpertise = async (id, expertise) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/update`, { id: id, ...expertise });
        return response.data;
    } catch (error) {
        console.error(`Error updating expertise with id ${id}`, error);
        throw error;
    }
};

export const deleteExpertise = async (id) => {
    try {
        const response = await axiosInstance.post(`${API_URL}/delete/`, { id: id });
        return response.data;
    } catch (error) {
        console.error(`Error deleting expertise with id ${id}`, error);
        throw error;
    }
};

